import { Component, OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { AppConfigService } from '@core/services/config.service';
import {
    FormGroup,
    FormBuilder,
    Validators,
    FormControl
} from '@angular/forms';
import { LocalStorageService } from 'ngx-webstorage';
import { Router, ActivatedRoute } from '@angular/router';

import { Subject } from 'rxjs';
import { LocalService } from '../local.services';
import { takeUntil } from 'rxjs/operators';
import { Local } from '@core/models/local.model';
import { ScrollService } from '../scroll.services';
import { ProgressService } from '../probress-steps/progress.services';
import { AppValidate } from '../validate';
import { ToastrService } from 'ngx-toastr';
@Component({
    selector: 'app-local-step-3',
    templateUrl: './step3.component.html',
    styleUrls: ['./step3.component.scss']
})
export class AppStep3Component implements OnInit, AfterViewInit, OnDestroy {
    local_id: any;
    loading = false;
    regForm: FormGroup;
    regFormErrors: any;
    local: Local;
    private _unsubscribeAll: Subject<any>;
    relations: any[];

    constructor(
        private _appConfig: AppConfigService,
        private activatedRoute: ActivatedRoute,
        private _scrollService: ScrollService,
        private _formBuilder: FormBuilder,
        private _router: Router,
        private _toastr: ToastrService,
        private _progressService: ProgressService,
        private _localService: LocalService
    ) {
        this._appConfig.setSettings({
            layout: {
                navigation: 'left',
                toolbar: 'above',
                header: {
                    home: false,
                    register: true,
                    fixed: true
                },
                footer: {
                    home: false,
                    register: true,
                    fixed: true
                }
            }
        });

        this.regFormErrors = {
            contact_name: {},
            contact_lastname: {},
            contact_email: {},
            contact_phone: {},
            owner_relationship: {}
        };
        this.local = new Local();
        this._unsubscribeAll = new Subject();
        this.relations = ['Familiar directo', 'Broker', 'Otros'];
    }
    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe(queryParams => {
            this.activatedRoute.params.subscribe(routeParams => {
                this.local_id = routeParams.id;
            });
        });

        this.regForm = this._formBuilder.group({
            contact_name: [''],
            contact_lastname: [''],
            contact_email: [''],
            contact_phone: [''],
            owner_relationship: ['']
        });

        this.regForm.valueChanges.subscribe(form => {
            this.onRegisterFormValuesChanged();
        });
        this._localService.localOnChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(local => {
                this.local = new Local(local);
                this.regForm.patchValue(this.local);
            });

        this.handleChanges();
    }

    ngAfterViewInit() {
        this._scrollService._init();
    }

    handleChanges() {
        AppValidate.Email(<FormControl>this.regForm.get('contact_email'));
        AppValidate.Number(<FormControl>this.regForm.get('contact_phone'));
    }

    onSubmit() {
        if (this.regForm.valid) {
            const data = this.regForm.getRawValue();
            if (!this.emptyValues(data)) {
                data.steps = this._progressService.getCurrentIndex(3);
            } else {
                data.steps = this._progressService.removeCurrentIndex(3);
            }
            this._localService
                .update(data)
                .then((res: any) => {
                    this._router.navigate([
                        `/local/registro/4/${this.local_id}`
                    ]);
                })
                .catch((err: any) => {
                    this._toastr.error(
                        'Ocurrió un error, inténtalo nuevamente.'
                    );
                });
        }
    }
    private emptyValues(value: any) {
        if (value.contact_email === null || value.contact_email === '') {
            return true;
        }

        if (value.contact_lastname === null || value.contact_lastname === '') {
            return true;
        }

        if (value.contact_name === null || value.contact_name === '') {
            return true;
        }

        if (value.contact_phone === null || value.contact_phone === '') {
            return true;
        }

        if (
            value.owner_relationship === null ||
            value.owner_relationship === ''
        ) {
            return true;
        }

        return false;
    }

    prev() {
        this._router.navigate([`/local/registro/2/${this.local_id}`]);
    }

    skip() {
        this._router.navigate([`/local/registro/4/${this.local_id}`]);
    }
    onRegisterFormValuesChanged() {
        for (const field in this.regFormErrors) {
            if (!this.regFormErrors.hasOwnProperty(field)) {
                continue;
            }
            this.regFormErrors[field] = {};
            const control = this.regForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.regFormErrors[field] = control.errors;
            }
        }
    }

    /*  contact_name */
    get contact_name() {
        return this.regForm.get('contact_name');
    }
    get contact_name_value(): boolean {
        const _value = String(this.contact_name.value);
        return _value.length > 0 ? true : false;
    }

    /*  contact_lastname */
    get contact_lastname() {
        return this.regForm.get('contact_lastname');
    }
    get contact_lastname_value(): boolean {
        const _value = String(this.contact_lastname.value);
        return _value.length > 0 ? true : false;
    }

    /*  contact_email */
    get contact_email() {
        return this.regForm.get('contact_email');
    }
    get contact_email_value(): boolean {
        const _value = String(this.contact_email.value);
        return _value.length > 0 ? true : false;
    }

    /*  contact_email */
    get contact_phone() {
        return this.regForm.get('contact_phone');
    }
    get contact_phone_value(): boolean {
        const _value = String(this.contact_phone.value);
        return _value.length > 0 ? true : false;
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
